import 'current-script-polyfill'
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { VLazyImagePlugin } from "v-lazy-image";
import Icon from "./components/Icon.vue";
import Loader from "./components/Loader.vue";
import GetTextPlugin from 'vue-gettext'
import translations from './assets/json/translations.json'
import {getUserFromSession, setupLoginGuard} from './utils/authentication'
import './utils/validation'
import './utils/axios-config'
import checkForTouch from './utils/check-for-touch'
import './styles/styles.scss'
import vSelect from "vue-select";
import OpenIndicator from "./components/vSelectOpenIndicator.vue";
import Deselect from "./components/vSelectDeselect.vue";
import "vue-select/src/scss/vue-select.scss";

// touch
checkForTouch();

// swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

// select
Vue.component("v-select", vSelect);
vSelect.props.components.default = () => ({ OpenIndicator, Deselect });

// puma button component
import puma_button from './components/PumaButton.vue'
Vue.component('puma-button', puma_button);

Vue.config.productionTip = false;


// Setup translations
Vue.use(GetTextPlugin, {
    availableLanguages: {
      en: 'English',
      de: 'Deutsch',
    },
    translations: translations, 
    // defaultLanguage: localStorage.getItem('pmcLanguage') ? localStorage.getItem('pmcLanguage') : 'en'}
    defaultLanguage: localStorage.getItem('pmcLanguage') ? localStorage.getItem('pmcLanguage') : 'de'}
)
  

Vue.use(VLazyImagePlugin);
Vue.use(VueAwesomeSwiper);

Vue.component('Icon', Icon);
Vue.component('Loader', Loader);

getUserFromSession();
setupLoginGuard();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
